import { useTranslation } from "react-i18next";
import { createFormContext } from "@mantine/form";
import { QuestionInput, Questionnaire, QuestionnaireInput } from "src/graphql/generated/graphql";
import { DeepPartial } from "src/types/utils";

import { getQuestionnaireQuestionErrors } from "../CreateCampaignInquiryForm/utils";

export const parseQuestionnaireInput = (questionnaire: Questionnaire): QuestionnaireInput => {
    return questionnaire;
};

export const [QuestionnaireFormProvider, useQuestionnaireFormContext, useForm] =
    createFormContext<QuestionnaireInput>();

export const useQuestionnaireForm: typeof useForm = (values) => {
    const { t } = useTranslation(["common"]);

    return useForm({
        ...values,
        initialValues: {
            ...values.initialValues,
            questions: values.initialValues?.questions || [],
        },
        // R10b: the same field-level rules the inquiry form runs under its own
        // `questionnaire.questions.N.…` prefix (CreateCampaignInquiryForm/utils.ts's
        // getQuestionnaireQuestionErrors, R10) — reused verbatim, including its
        // type-awareness (options only error for radio/checkbox) and its "no authored
        // content" exemption (test-spec.md §3.2), rather than re-derived here. Keyed off
        // THIS form's own `questions.N.…` because that is what QuestionsEditorForm's
        // inputs are actually bound to; the inquiry form stays the one that refuses the
        // submit (CreateCampaignInquiry/index.tsx wires both on submit).
        validate: (formValues) =>
            getQuestionnaireQuestionErrors(formValues?.questions as DeepPartial<QuestionInput>[], t, "questions"),
    });
};
